import { Anchor, Users, Ship, Gauge, Calendar as CalIcon, Settings } from "lucide-react";

const STATS = [
  { icon: Ship,    label: "Vessel",   value: "Hatteras Convertible · 55 ft" },
  { icon: CalIcon, label: "Year",     value: "1981 · meticulously maintained" },
  { icon: Settings,label: "Engines",  value: "Twin 650 HP Detroit Diesel" },
  { icon: Gauge,   label: "Max speed",value: "28 knots" },
  { icon: Users,   label: "Capacity", value: "Up to 10 guests" },
  { icon: Anchor,  label: "Crew",     value: "Captain Vaughn + crew of 4" },
];

export default function Vessel() {
  return (
    <section id="vessel" data-testid="vessel-section" className="aq-section aq-bg-foam">
      <div className="aq-container grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <span className="aq-overline">The Vessel</span>
          <h2 className="aq-h2 text-4xl sm:text-5xl mt-4" style={{ color: "var(--aq-navy)" }}>
            A 55-foot Hatteras built for the deep blue.
          </h2>
          <span className="aq-divider" />
          <p className="text-base text-[15px] leading-relaxed" style={{ color: "var(--aq-text-soft)" }}>
            Aquarius is a 1981 Hatteras Convertible — the classic Carolina-style sportfisher
            that built American big-game fishing. Twin 650 HP Detroit Diesels push her at
            up to 28 knots, so the deep water 5 to 8 miles off the Ocho Rios coast is
            twenty fast minutes away.
          </p>
          <p className="text-base text-[15px] leading-relaxed mt-4" style={{ color: "var(--aq-text-soft)" }}>
            On board: a tournament fighting chair, outriggers, full electronics
            (GPS, radar, sounder), an air-conditioned salon with TV and multimedia,
            galley, refrigerator and ice box, private head with shower, and a bed for
            guests who want a nap between bites. Snorkeling gear stays in the lazarette
            for the spots where the fishing winds down.
          </p>
        </div>

        <div className="lg:col-span-7">
          <div className="aq-gallery-tile" style={{ aspectRatio: "16 / 9" }}>
            <img src="/brand/aquarius_vessel_profile.jpg" alt="Aquarius — 55-foot Hatteras Convertible at Ocho Rios Marina" loading="lazy" />
          </div>
          <div className="grid grid-cols-2 gap-4 mt-6">
            {STATS.map((s) => (
              <div key={s.label} className="aq-card p-5" data-testid={`vessel-stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}>
                <s.icon size={20} style={{ color: "var(--aq-gold)" }} />
                <div className="aq-overline mt-3">{s.label}</div>
                <div className="aq-serif text-lg mt-1.5" style={{ color: "var(--aq-navy)" }}>{s.value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
